import React, { Component } from "react";
import { Modal, Table, Input, Select, Checkbox, Tag, message, Alert } from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { cmmsPost, cargarSucursales, estatusEquipo } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

// Agregar al contrato equipos del cliente (por filtro y seleccion multiple) y elegir en que
// vueltas les toca servicio. Los que estan en otro contrato salen marcados.
class ModalAgregarEquiposContrato extends Component {
    state = { candidatos: [], cargando: false, guardando: false, seleccion: [], texto: "", direccionId: null, tipoEquipoId: null, tipos: [], sucursales: [], vueltasIds: [] };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            this.setState({ seleccion: [], texto: "", direccionId: null, tipoEquipoId: null, vueltasIds: (this.props.contrato?.vueltas || []).map((v) => v._id) }, this.buscar);
            this.cargarCatalogos();
        }
    }

    cargarCatalogos = async () => {
        const [tipos, sucursales] = await Promise.all([
            cmmsPost(this.props, "selectTiposEquipo", { valor: 1 }).then((r) => (r.data.success === 2 ? r.data.tipos : [])),
            cargarSucursales(this.props, this.props.contrato?.clienteId),
        ]);
        this.setState({ tipos, sucursales });
    };

    buscar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "candidatosContratoCMMS", {
                contratoId: this.props.contrato._id,
                texto: this.state.texto,
                direccionId: this.state.direccionId,
                tipoEquipoId: this.state.tipoEquipoId,
            });
            this.setState({ candidatos: res.data.success === 2 ? res.data.equipos : [] });
        } finally {
            this.setState({ cargando: false });
        }
    };

    aceptar = async (mover = false) => {
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "agregarEquiposContratoCMMS", {
                contratoId: this.props.contrato._id,
                activosIds: this.state.seleccion,
                vueltasIds: this.state.vueltasIds,
                mover,
            });
            if (res.data.success === 3) {
                Modal.confirm({ title: "Equipos en otro contrato", content: res.data.message, okText: "Moverlos a este contrato", cancelText: "Regresar", onOk: () => this.aceptar(true) });
            } else if (res.data.success === 2) {
                message.success(`${res.data.agregados} equipo(s) agregados · ${res.data.planesCreados} servicio(s) programados`);
                this.props.onClose(true);
            } else message.error(res.data.message || "No se pudieron agregar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { visible, contrato } = this.props;
        const vueltas = contrato?.vueltas || [];
        const enOtro = this.state.candidatos.filter((c) => this.state.seleccion.includes(c._id) && c.otroContrato).length;
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={() => this.props.onClose(false)}
                onOk={() => this.aceptar(false)}
                okText={`Agregar ${this.state.seleccion.length || ""} equipo(s)`}
                cancelText="Cancelar"
                okButtonProps={{ disabled: !this.state.seleccion.length || !this.state.vueltasIds.length }}
                confirmLoading={this.state.guardando}
                width={window.innerWidth > 1100 ? 1040 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <AppstoreAddOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">Agregar equipos al contrato</div>
                            <div className="cmms-modal-subtitulo">Equipos del cliente. A cada uno se le programa un servicio en las vueltas elegidas (sin fecha todavía).</div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
                        <Input.Search
                            placeholder="Buscar folio, serie, inventario, modelo, ubicación..."
                            allowClear
                            style={{ width: 320 }}
                            value={this.state.texto}
                            onChange={(e) => this.setState({ texto: e.target.value })}
                            onSearch={() => this.buscar()}
                        />
                        <Select allowClear placeholder="Todas las sucursales" style={{ width: 240 }} value={this.state.direccionId || undefined} onChange={(direccionId) => this.setState({ direccionId: direccionId || null }, this.buscar)}>
                            {this.state.sucursales.map((s) => (
                                <Option key={s._id} value={s._id}>
                                    {s.nombre}
                                </Option>
                            ))}
                        </Select>
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder="Todos los tipos"
                            style={{ width: 220 }}
                            value={this.state.tipoEquipoId || undefined}
                            onChange={(tipoEquipoId) => this.setState({ tipoEquipoId: tipoEquipoId || null }, this.buscar)}
                        >
                            {this.state.tipos.map((t) => (
                                <Option key={t._id} value={t._id}>
                                    {t.nombre}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, flexWrap: "wrap", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#4a5866" }}>
                            {this.state.candidatos.length} equipo(s) ·{" "}
                            <a href="#todos" onClick={(e) => { e.preventDefault(); this.setState({ seleccion: this.state.candidatos.map((c) => c._id) }); }}>
                                seleccionar todos
                            </a>{" "}
                            ·{" "}
                            <a href="#ninguno" onClick={(e) => { e.preventDefault(); this.setState({ seleccion: [] }); }}>
                                ninguno
                            </a>
                        </span>
                        <span style={{ fontSize: 12 }}>
                            <b>Incluir en: </b>
                            <Checkbox.Group options={vueltas.map((v) => ({ label: v.nombre, value: v._id }))} value={this.state.vueltasIds} onChange={(vueltasIds) => this.setState({ vueltasIds })} />
                        </span>
                    </div>
                    {!vueltas.length && <Alert type="warning" showIcon style={{ marginBottom: 8 }} message="El contrato no tiene vueltas: agréguelas en el paso Vueltas para poder programar los equipos." />}
                    {enOtro > 0 && (
                        <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 8 }}
                            message={`${enOtro} de los seleccionados están en otro contrato: se moverán a éste y de aquel se borra lo pendiente que no tiene Orden de Servicio.`}
                        />
                    )}
                    <Table
                        size="small"
                        rowKey="_id"
                        loading={this.state.cargando}
                        dataSource={this.state.candidatos}
                        pagination={{ pageSize: 50, showSizeChanger: false, size: "small" }}
                        scroll={{ y: 380 }}
                        rowSelection={{ selectedRowKeys: this.state.seleccion, onChange: (seleccion) => this.setState({ seleccion }), preserveSelectedRowKeys: true }}
                        locale={{ emptyText: "No hay equipos del cliente fuera de este contrato" }}
                        columns={[
                            { title: "Equipo", dataIndex: "activoTexto", render: (v, r) => (<span>{v} {r.otroContrato ? <Tag color="gold">En {r.otroContrato.nombre} ({r.otroContrato.estatusNombre})</Tag> : null}</span>) },
                            { title: "Inventario", dataIndex: "numeroInventario", width: 110 },
                            { title: "Sucursal", dataIndex: "sucursalNombre", width: 200 },
                            { title: "Ubicación", width: 160, render: (r) => [r.ubicacion, r.area].filter(Boolean).join(" · ") },
                            { title: "Estatus", dataIndex: "estatusEquipo", width: 120, render: (v) => <Tag color={estatusEquipo(v).color}>{estatusEquipo(v).label}</Tag> },
                        ]}
                    />
                </div>
            </Modal>
        );
    }
}

export default ModalAgregarEquiposContrato;
